import { render, staticRenderFns } from "./FansFollow.vue?vue&type=template&id=768093e6&scoped=true"
import script from "./FansFollow.vue?vue&type=script&lang=js"
export * from "./FansFollow.vue?vue&type=script&lang=js"
import style0 from "./FansFollow.vue?vue&type=style&index=0&id=768093e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768093e6",
  null
  
)

export default component.exports